// 添加编辑爱车
<template>
    <div class="car-item">
        <van-card>
            <template slot="thumb">
                <div class="thumb">
                    <van-image
                        width="40"
                        height="40" 
                        src="https://public.qiniu.xcims.com/wx_caritem.png"/>
                    <div class="del" @click="delItem">删除</div>
                </div>
            </template>
            <template slot="title">
                <van-row>
                    <van-col>
                        <span class="title">
                            {{ area }}{{ code }}
                        </span>
                    </van-col>
                    <van-col>
                        <van-checkbox v-model="isdefault" icon-size="16px" @click="setItem">默认否</van-checkbox>
                    </van-col>
                </van-row>
            </template>
            <template slot="desc">
                <div class="desc">{{ carcategory }}</div>
            </template>
        </van-card>
    </div>
</template>

<script>
import { 
    Card,
    Image,
    Tag,
    Row,
    Col,
    Checkbox
 } from 'vant'

export default {
    name: 'CarItem',
    components: {
        [Card.name]: Card,
        [Image.name]: Image,
        [Tag.name]: Tag,
        [Row.name]: Row,
        [Col.name]: Col,
        [Checkbox.name]: Checkbox
    },
    props: ["area", "code", "carcategory", "isdefault",],
    data() {
        return {
            visible: false
        }
    },
    methods: {
        delItem() {
            this.$emit('delItem', {})
        },
        cancel() {
            this.visible = false
        },
        setItem() {
            this.$emit('setItem', {})
        }
    }
}
</script>

<style lang="less">
.car-item {
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  color: white;

  .van-card {
      padding-top: 20px;
      background-color: #203864;

      .thumb {
          margin-top: 12px;
          text-align: center;

          .del {
              margin-top: 3px;
              color: #B5D0F9;
          }
      }

      .title {
        font-size: 1.2em;
        font-weight: bold;
        padding-bottom: 6px;
        padding-top: 6px;
        color: #D8D8D8;
        margin-right: 8px;
    }
    
    .van-checkbox__label {
        color: #B5D0F9;
    }

    .desc {
        margin-top: 8px;
        color: #B5D0F9;
    }
  }
}
</style>
